import type { SettingsSectionId } from './sectionRegistry';

export const PROJECT_SETTINGS_URL = '/projects?tab=settings';

export const settingsSectionUrl = (id: SettingsSectionId) => `${PROJECT_SETTINGS_URL}&sub=${id}`;

export const rateCardUrl = (cardId: string) =>
  `${settingsSectionUrl('rate-cards')}&card=${encodeURIComponent(cardId)}`;

/**
 * Admin's old `?tab=` values for the lists that moved to Projects → Settings.
 * `projects` was the slug of their whole rail group, so it opens the caller's
 * default section rather than naming one.
 */
const MOVED_ADMIN_TABS: Record<string, string> = {
  stages: settingsSectionUrl('stages'),
  types: settingsSectionUrl('types'),
  meta: settingsSectionUrl('fields'),
  'detail-templates': settingsSectionUrl('templates'),
  rates: settingsSectionUrl('rate-cards'),
  projects: PROJECT_SETTINGS_URL,
};

/** Where an old `/admin?tab=` link now lives, or `null` when it still lives in Admin. */
export function settingsUrlFor(adminTab: string | null): string | null {
  if (adminTab === null) return null;
  return Object.hasOwn(MOVED_ADMIN_TABS, adminTab) ? MOVED_ADMIN_TABS[adminTab] : null;
}
